module.exports = __webpack_public_path__ + "img/bg3.d59b1e34.png";